import React, { useState } from "react";
import Select from "react-select";
import dropdown_arrow from "../../images/icons/dropdown_arrow.png";

import "./SelectFilter.css";

const SelectFilter = ({
  selectedOption,
  setSelectedOption,
  options,
  defaultValue,
}) => {
  const [isClick, setIsClick] = useState(false);

  const value = { value: defaultValue, label: defaultValue };

  function handleOptionChange(option) {
    setSelectedOption(option);
  }

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      "&:hover": {
        borderColor: state.isFocused ? "blue" : "gray",
      },
      width: 200,
      border: "1px solid #E5E7EB",
      boxShadow: "none",
      height: 20,
    }),
  };
  const placeHolder = "Select an option";

  return (
    <div>
      <Select
        components={{
          DropdownIndicator: () => {
            return (
              <img
                src={dropdown_arrow}
                className="arrow_icon"
                alt="arrow_icon"
                onClick={() => {
                  setIsClick(!isClick);
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    setIsClick(!isClick);
                  }
                }}
              />
            );
          },
        }}
        placeholder={placeHolder}
        value={selectedOption || value}
        onChange={handleOptionChange}
        options={options}
        styles={customStyles}
      />
    </div>
  );
};

export default SelectFilter;
